import { render, staticRenderFns } from "./ModalVerificationCode.vue?vue&type=template&id=19427ab2&lang=html&"
import script from "./ModalVerificationCode.vue?vue&type=script&lang=js&"
export * from "./ModalVerificationCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports